import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";
export default class Mkb100 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      index: 0,
      response: null,
      postCount: 0,
      status: "Active",
      statelist: [],
      selectedstate: {},
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
    };
    this.update = this.update.bind(this);
    // this.getPosts = this.getPosts.bind(this);
    this.batchUpdate = this.batchUpdate.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
    this.stateList = this.stateList.bind(this);
  }
  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      //   status = "disabled";
      status = "enabled";
    }

    // this.getPosts(status);
    this.stateList();
  }
  componentWillReceiveProps(nextProps) {
    var status = nextProps.match.params.status;
    if (!status) {
      //   status = "disabled";
      status = "enabled";
    }
    this.setState({ lastEvaluatedKey: "" }, () => {
      this.getPosts(status);
    });
    // this.getPosts(status);
  }

  stateListvalue = (e, loadmore, del) => {
    if (e && !loadmore) {
      this.setState({ index: 0, items: [] });
    }
    this.setState({ selectedstate: e ? e : del ? del : "" });
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify({
        action: "mkb100",
        state: del ? del : e,
        // index: this.state.index,
        index: e && !loadmore ? 0 : this.state.index,
      }),
    };

    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          if (result.response.length > 99) {
            ref.setState(
              {
                loadMoreDisplay: true,
                index: ref.state.index + 1,
                response: result,
                items: [...ref.state.items, ...result.response],
                post_count: postCount,
                type: "mkb100",
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          } else {
            ref.setState(
              {
                loadMoreDisplay: false,
                response: result,
                items: result.response,
                post_count: postCount,
                type: "mkb100",
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          // ref.setState(
          //   {
          //     response: response,
          //     items: response.items,
          //     post_count: postCount,
          //     type: response.type,
          //   },
          //   () => {
          //     $("#loader").css({ display: "none" });
          //   }
          // );
        }
      } catch (ex) {}
    });
  };
  batchUpdate(status) {
    var ids = [];
    var createds = [];
    $(".multi_select:checked").each(function () {
      ids.push($(this).attr("data-id"));
      createds.push($(this).attr("data-created"));
    });
    var id = ids.join(",");
    var created = createds.join(",");

    if (id == "") {
      alert("No post selected");
    } else {
      this.update(id, created);
    }
  }

  update(id, created, status) {
    id = "" + id;
    var request = doRequest(
      "cms-operations2",
      {
        action: "update-post",
        module: "mahilamorcha2023",
        model: "post",
        data: {
          id: id.toString(),
          status: status,
          created: created,
        },
      },
      true
    );

    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          $("#post_" + id).hide();
        }
      } catch (ex) {}
    });
  }
  loadMoreData = () => {
    this.stateListvalue(this.state.selectedstate, "loadmore", "");
  };
  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }
  handlePhotoSelect = (photoId) => {
    const { selectedPhotos } = this.state;
    if (selectedPhotos.includes(photoId)) {
      this.setState({
        selectedPhotos: selectedPhotos.filter((id) => id !== photoId),
      });
    } else {
      this.setState({ selectedPhotos: [...selectedPhotos, photoId] });
    }
  };

  downloadSelectedPhotos = () => {
    const { items } = this.state;
    const { selectedPhotos } = this.state;
    if (selectedPhotos.length > 5) {
      alert("You can download a maximum of 5 photos at once.");
      return;
    }
    selectedPhotos.forEach((id) => {
      const photo = items.find((p) => p.id === id);
      if (photo) {
        const fileUrl = photo.image_url;
        const fileName = `${photo.name}`;
        saveAs(fileUrl, fileName);
      }
    });
  };

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };
  downloadPhotos = (photo) => {
    saveAs(photo.image_url, photo.name);
  };

  stateList = () => {
    var form = new FormData();
    form.append("action", "getstatelist");
    form.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    form.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");

    var settings = {
      url: "https://api.narendramodi.in/mlapiv1",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "ADRUM_BT=R%3A0%7Cg%3A48c9d406-532c-4eef-98d3-f21dad96c84c6%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29062%7Cd%3A12%7Ce%3A566",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    let ref = this;
    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState({
            statelist: response.data,
          });
          let del =
            response &&
            response.data.length > 0 &&
            response.data.filter((stateval) => stateval.statename === "Delhi");
          let requiredState = del[0];
          ref.setState(
            {
              selectedstate: requiredState.statename,
            },
            () => {
              ref.stateListvalue("", "loadmore", requiredState.statename);
            }
          );
        }
      } catch (ex) {}
    });
  };

  render() {
    console.log(this.state.selectedstate);
    var stateList = this.state.statelist;
    var bread = "MKB 100 / Moderation (Disabled Posts)";
    var pagelink = "/gujaratelection/moderation";
    if (this.props.match.params.status == "disabled") {
      bread = "MKB 100/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (this.props.match.params.status == "enabled") {
      bread = "MKB 100/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    } else {
      bread = "MKB 100/ Moderation (Enabled Posts)";
      pagelink += "/disabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/mahilamorcha/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/mahilamorcha/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;
    return (
      <div>
        <PageTitle
          title="#MKB 100"
          bread={bread}
          //   links={links}
          Count={this.state.postCount}
        />
        <br />
        {/* <a
          href="javascript:void(0);"
          title="Download max 5 images"
          onClick={() => this.downloadSelectedPhotos()}
        >
          <img src="/img/download1.png" alt="Download" />
        </a>
        <a
          href="javascript:void(0);"
          style={{ position: "absolute", right: "30px" }}
          onClick={() => this.UnselectChekbox()}
        >
          <i className="fa fa-uncheck"></i>&nbsp;Uncheck All
        </a> */}
        <div className="form-inline form_right" style={{ top: "0px" }}>
          <div className="row row_date_div">
            <div
              className="row"
              style={{
                "margin-right": "10px",
                "margin-left": "100px",
              }}
            >
              <select
                id="state"
                name="state"
                className="form-control rigt_mar"
                onChange={(e) => this.stateListvalue(e.target.value)}
                value={this.state.selectedstate}
              >
                <option value="">Select Your State</option>
                <option value="null">N/A</option>
                {Array.isArray(stateList) &&
                  stateList.map((val, i) => {
                    return (
                      <option
                        value={val.statename}
                        key={i}
                        // data-value={val.stateid}
                      >
                        {val.statename}
                      </option>
                    );
                  })}
              </select>
            </div>

            <button
              style={{
                // padding: "0px 10px",
                "border-radius": "20px",
                "margin-left": "10px",
              }}
              className="btn-success"
              onClick={() => {
                window.location.reload();
              }}
            >
              Clear filters
            </button>
          </div>
        </div>
        <div className="wrapper wrapper-content">
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div
                        className="file-box"
                        key={index}
                        id={"post_" + value.id}
                      >
                        <div className="file">
                          <a href="javascript:void(0);">
                            <span className="corner"></span>
                            <LazyLoad>
                              <div className="image" style={{ height: "auto" }}>
                                {/* <input
                                  type="checkbox"
                                  checked={selectedPhotos.includes(value.id)}
                                  onChange={() =>
                                    this.handlePhotoSelect(value.id)
                                  }
                                /> */}
                                <a
                                  href={`https://api.narendramodi.in/api/loadone?link=${value.image_url}&x=www.facebook.com`}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "1px",
                                  }}
                                  target="_blank"
                                  //   onClick={() => this.downloadPhotos(value)}
                                >
                                  <img src="/img/download.svg" alt="Download" />
                                </a>
                                <img
                                  style={{ "margin-top": "25px" }}
                                  alt="image"
                                  className="img-responsive"
                                  src={value.image_url}
                                />
                              </div>
                            </LazyLoad>
                            <div className="file-name">
                              {value.name ? value.name : ""}
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Mkb100/Moderation.jsx